// src/pages/PurchasesPage.js
import React, { useState, useEffect } from 'react';
import {
    Box, Button, Typography, CircularProgress, Modal, TextField
} from '@mui/material';
import {  esES } from '@mui/x-data-grid/locales';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import api from '../api/index.js';
import PurchasePaymentsModal from './PurchasePaymentsModal.js';

// Estilo para el modal (puedes moverlo a un archivo central si lo usas mucho)
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const PurchasesPage = () => {
    // --- ESTADOS ---
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    
    // Estados para el modal de pago
    const [openPayModal, setOpenPayModal] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState('');
    const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);
const [paymentsModalOpen, setPaymentsModalOpen] = useState(false);
    const [selectedPurchaseId, setSelectedPurchaseId] = useState(null);

    const handleOpenPayments = (id) => {
        setSelectedPurchaseId(id);
        setPaymentsModalOpen(true);
    };

    // --- FUNCIONES ---
    const fetchPurchases = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/purchases?timestamp=${new Date().getTime()}`);
            setPurchases(response.data);
        } catch (error) {
            console.error("Error al obtener las compras:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPurchases();
    }, []);

    const handleOpenPayModal = (purchase) => {
        setSelectedPurchase(purchase);
        // Sugerir el monto pendiente, asegurando que sea un número
        setPaymentAmount(Number(purchase.pending_balance) || '');
        setPaymentDate(new Date().toISOString().split('T')[0]);
        setOpenPayModal(true);
    };
    const handleClosePayModal = () => setOpenPayModal(false);

    const handleRegisterPayment = async () => {
        if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
            alert('Por favor, introduce un monto válido.');
            return;
        }
        try {
            await api.post(`/purchases/${selectedPurchase.id}/pay`, {
                amount: parseFloat(paymentAmount),
                payment_date: paymentDate,
            });
            handleClosePayModal();
            await fetchPurchases(); // Recargar la lista
        } catch (error) {
            alert(error.response?.data?.message || 'Error al registrar el pago.');
        }
    };

    // --- DEFINICIÓN DE COLUMNAS ---
    const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'supplier_name', headerName: 'Proveedor', width: 220 },
    { field: 'store_name', headerName: 'Tienda Destino', width: 220 },
    { field: 'invoice_number', headerName: 'N° Factura', width: 150 },
    { 
        field: 'total_amount', headerName: 'Monto Total', width: 150, type: 'number',
        valueFormatter: (params) => `$${Number(params.value || 0).toFixed(2)}`
    },
    { field: 'status', headerName: 'Estado', width: 150 },
    { 
        field: 'created_at', headerName: 'Fecha Creación', width: 180,
        type: 'dateTime',
        valueGetter: (params) => new Date(params.value),
    },
    // --- SOLO UNA DEFINICIÓN DE 'actions' ---
    {
        field: 'actions',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        renderCell: (params) => (
            <Button size="small" onClick={() => handleOpenPayments(params.row.id)}>
                Ver Pagos
            </Button>
        )
    }
];

    // --- RENDERIZADO ---
    return (
        <Box sx={{ height: '85vh', width: 'width: 100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5">
                    Historial de Compras
                </Typography>
                <Button 
                    variant="contained" 
                    onClick={() => navigate('/purchases/new')}
                >
                    Registrar Nueva Compra
                </Button>
            </Box>
            <DataGrid
                rows={purchases}
                columns={columns}
                loading={loading}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            />
            {/* Modal de Pago */}
            <Modal open={openPayModal} onClose={handleClosePayModal}>
                <Box sx={style}>
                    <Typography variant="h6">Registrar Abono a Factura {selectedPurchase?.invoice_number}</Typography>
                    <Typography>Saldo Pendiente: ${Number(selectedPurchase?.pending_balance || 0).toFixed(2)}</Typography>
                    
                    <TextField
                        margin="normal" required fullWidth autoFocus
                        label="Monto a Abonar" type="number"
                        value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)}
                    />
                    <TextField
                        margin="normal" required fullWidth
                        label="Fecha de Pago" type="date"
                        value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleClosePayModal} sx={{ mr: 1 }}>Cancelar</Button>
                        <Button variant="contained" onClick={handleRegisterPayment}>Confirmar Pago</Button>
                    </Box>
                               
                </Box>
            </Modal>
        <PurchasePaymentsModal
                open={paymentsModalOpen}
                onClose={() => setPaymentsModalOpen(false)}
                purchaseId={selectedPurchaseId}
                onUpdate={fetchPurchases} // Pasamos la función de recarga
            />
        
        </Box>
    );
};

export default PurchasesPage;